module.exports = __webpack_public_path__ + "img/partner_grafisoft.7ea00ce8.png";